import {store} from '../../../store/store'
import page from '../../../components/page'
import search from '../../../components/search'
import activity from '../../../components/activity.vue'
import {api,getHallCode} from "../../../common/config";
import {ajaxUtil} from '../../../common/AjaxUtil.js';
import {CommonUtil} from '../../../common/CommonUtil.js';
import {StorageUtil, LocalStorageUtil} from '../../../common/Auth.js';

export default {
  name: "activitylist",
  data() {
    return {
        webType: store.webType,
        locationCode:'',
        libCode:'',
        pageCount:3,
        pageNo:1,
        activityListData:{},
        idS:[],
        totalPage:0,
    }
  },
  components: {
    page,
    search,
    activity
  },
  beforeMount() {
    store.wrap.activeRouteName = '活动';
    this.queryData();
  },
watch:{
    $route(){
        this.queryData();
    }
},


  methods: {

    queryData(){
        this.locationCode = this.$route.query.code || "510107";
        this.libCode =this.$route.query.libCode ||　this.$route.query.hallCode;
        this.pageNo = this.$route.query.page || 1;
        var url;
        if(store.webType == 1) {
            url = api.activity.activitys.replace('{libCode}',this.libCode).replace('{keyword}', "").replace('{pageCount}', this.pageCount).replace('{pageNo}', this.pageNo);
        } else {
            url = api.activity.search.replace('{locationCode}', this.locationCode).replace('{pageCount}', this.pageCount).replace('{pageNo}', this.pageNo).replace('{keyword}', "");
        }
         ajaxUtil.ajaxJson(url, null, "GET", (data) => {
             this.activityListData = data;
             this.totalPage=data.totalPage;
            if (this.activityListData.resultList != null) {
                for (var i = 0; i < this.activityListData.resultList.length; i++) {
                    this.idS.push(this.activityListData.resultList[i].id);
                }
            }
        }, null, this);
    },

    intoInformationActivityDetail(id){
      let data = {
        ids: this.idS,
        totalCount: this.activityListData.totalCount,
        pageCount: this.pageCount,
        pageNo: this.pageNo,
        totalPage: this.activityListData.totalPage
      };
      StorageUtil.storeObject("activityInfo", data);
      this.$router.push({path: '/activitydetails', query: {activityId: id, code: this.locationCode, hallCode: this.libCode}});
    },
    paging: function (pageNo) {
      CommonUtil.mergeQuery(this,{page: pageNo})
    },
    //搜索
    toSearch(keywordInput){
      var searchStr=keywordInput.trim();
      if(searchStr==""){
        this.$router.push('/');
        return;
      }
      this.$router.push({path: 'indexsearch', query: {searchStr: searchStr, type:4,code:store.chooseArea.code,fromSearch:1,hallCode:this.libCode}});
    }

  }
}
